import type { AssignRequesterCustomerDraft, AssignRequesterCustomerRow } from "../contract"

export const defaultAssignRequesterCustomerDraft = (
  row: AssignRequesterCustomerRow,
): AssignRequesterCustomerDraft => {
  if (!row.needsStep) {
    return {
      decision: row.persistedDecision ?? "",
      customerId: row.persistedCustomerId,
      displayName: row.persistedDisplayName,
      email: row.persistedEmail,
      phone: row.persistedPhone,
      role: row.persistedRole,
    }
  }

  const selected = row.persistedCustomerId
    ? (row.customerOptions.find((candidate) => candidate.customerId === row.persistedCustomerId) ??
      null)
    : null
  const decision = row.persistedDecision ?? (selected ? "use_existing" : "create_new")

  return {
    decision,
    customerId: selected?.customerId ?? row.persistedCustomerId,
    displayName: row.persistedDisplayName || row.submittedName,
    email: selected?.email || row.submittedEmail,
    phone: selected?.phone || row.submittedPhone,
    role: row.persistedRole || selected?.role || row.suggestedRole,
  }
}

export const validateAssignRequesterCustomerDraft = (
  _row: AssignRequesterCustomerRow,
  draft: AssignRequesterCustomerDraft,
): string | null => {
  if (!draft.decision) return "Bitte wählen Sie eine Ansprechpartner-Entscheidung aus."

  if (draft.decision === "use_existing" && !draft.customerId) {
    return "Bitte wählen Sie einen bestehenden Ansprechpartner aus."
  }

  if (draft.decision === "create_new" && !draft.displayName.trim()) {
    return "Bitte geben Sie einen Namen für den neuen Ansprechpartner ein."
  }

  return null
}
